<template>
  <article class="c-row" :class="{ 'customer-updated': change }" :data-customer-id="customer.id">
    <button class="c-main" type="button" @click="$emit('open', customer)">
      <span class="c-when" :class="{ late: due.late }">
        {{ due.main }}<small>{{ due.sub }}</small>
        <span v-if="change" class="c-updated">{{ change.kind === 'followup' ? '已跟进' : '已更新' }}</span>
      </span>
      <span class="c-text">
        <span class="c-need">{{ need }}</span>
        <span class="c-meta"><b>{{ customer.name || '未填写姓名' }}</b>{{ meta }}</span>
        <span v-if="latestFollowup" class="c-followup">最新：{{ latestFollowup }}</span>
      </span>
    </button>
    <a v-if="actions && callable" class="c-dial" :href="'tel:' + customer.mobile" :aria-label="'拨打' + (customer.name || '客户')">
      <app-icon name="phone" />
    </a>
    <span v-else-if="actions" class="c-dial off" title="联系方式受权限保护">
      <app-icon name="phone" />
    </span>
  </article>
</template>
<script>
import { canCall } from '../common/customer'
import { dueInfo, needText, tail } from '../common/when'
export default {
  props: { customer: { type: Object, required: true }, actions: { type: Boolean, default: true } },
  computed: {
    change() { return this.$store.state.customerChanges[this.customer.id] || null },
    latestFollowup() { return String(this.customer.log_content || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim() },
    callable() {
      return canCall(this.customer.mobile)
    },
    due() {
      return dueInfo(this.customer.log_time)
    },
    need() {
      return needText(this.customer)
    },
    meta() {
      const c = this.customer
      return [tail(c.mobile), c.labels_text ? c.labels_text + '级' : '', c.status_text, c.total_budget_range_text, c.source_channel_v2_text]
        .filter(Boolean)
        .map(text => ' · ' + text)
        .join('')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customer-card.vue